import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { purpurColorFunctionalWhite, purpurColorPurple300, purpurColorPurple800, } from '@purpurds/tokens/color/variables';
import styled, { keyframes } from 'styled-components';
import spacing from 'theme/spacing';
const RadioButtonLabel = styled.label `
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
`;
const StyledSpan = styled.span `
  margin-left: ${spacing.spacing12};
  font-size: 18px;
`;
const StyledInput = styled.input `
  cursor: pointer;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const RadioCheckmark = styled.span `
  position: absolute;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: ${purpurColorFunctionalWhite};
  border: 1px solid ${purpurColorPurple800};
  border-radius: 50%;
  font-size: 0;

  /* hidden inner dot */
  &::after {
    content: '';
    position: absolute;
    display: none;
    border-radius: 100%;
    height: ${spacing.spacing12};
    width: ${spacing.spacing12};
    top: 3px;
    left: 3px;
    background-color: ${purpurColorPurple800};
  }
`;
const RadioButtonWrapper = styled.label `
  position: relative;
  padding-left: ${spacing.spacing28};
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* hover */
  &:hover ${RadioCheckmark} {
    background-color: ${purpurColorPurple300};
  }

  /* checked */
  input:checked + ${RadioCheckmark} {
    background-color: ${purpurColorFunctionalWhite};
  }

  input:checked + ${RadioCheckmark}::after {
    display: block;
  }
`;
const spin = keyframes `
  to {
    transform: rotate(360deg);
  }
`;
export const CircleLoader = styled.span `
  position: absolute;
  left: 0;
  width: 18px;
  height: 18px;
  border: 2px solid ${purpurColorPurple300};
  border-top-color: ${purpurColorPurple800};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;
export const RadioButton = ({ checked, name, onClick, label, value, isFetching }) => (_jsx(RadioButtonLabel, { htmlFor: `${label}${name}`, children: _jsxs(RadioButtonWrapper, { children: [_jsx(StyledSpan, { children: label }), _jsx(StyledInput, { id: `${label}${name}`, checked: checked, value: value, type: "radio", onChange: onClick, name: name }), isFetching ? (_jsx(CircleLoader, {})) : (_jsx(RadioCheckmark, {}))] }) }));
